import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TopicContainerModel } from '../../../../../../models';
import { ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';


@Injectable({providedIn: 'root'})

export class TopicService extends BaseApiPublicLoginTemplateService<TopicContainerModel, TopicContainerModel, TopicContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'topics';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'topics';

    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'topics/' + BaseApiTemplateService.PUBLIC_EP;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'topics/' + + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.httpClient = http;
  }

  updateImage(formData: FormData, imageGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/replace-file/' + imageGuid;
    console.log(this.apiUrl + 'photo', formData);
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/replace-file/' + imageGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  uploadImage(formData: FormData, extGuid, visa: ApiVisa) {
    let url = this.apiUrl + '/add-files/' + extGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/add-files/' + extGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }
}
